/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForIncorrectRequestsSummaryResponse
 */
export interface ReportForIncorrectRequestsSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof ReportForIncorrectRequestsSummaryResponse
     */
    countWithinLast1D: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForIncorrectRequestsSummaryResponse
     */
    countWithinLast2D: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForIncorrectRequestsSummaryResponse
     */
    countWithinLast1M: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForIncorrectRequestsSummaryResponse
     */
    countWithinLast2M: number;
}

export function ReportForIncorrectRequestsSummaryResponseFromJSON(json: any): ReportForIncorrectRequestsSummaryResponse {
    return ReportForIncorrectRequestsSummaryResponseFromJSONTyped(json, false);
}

export function ReportForIncorrectRequestsSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForIncorrectRequestsSummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countWithinLast1D': json['countWithinLast1D'],
        'countWithinLast2D': json['countWithinLast2D'],
        'countWithinLast1M': json['countWithinLast1M'],
        'countWithinLast2M': json['countWithinLast2M'],
    };
}

export function ReportForIncorrectRequestsSummaryResponseToJSON(value?: ReportForIncorrectRequestsSummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countWithinLast1D': value.countWithinLast1D,
        'countWithinLast2D': value.countWithinLast2D,
        'countWithinLast1M': value.countWithinLast1M,
        'countWithinLast2M': value.countWithinLast2M,
    };
}

